export default "__VITE_ASSET__UsNY2uBi__"